import { render, staticRenderFns } from "./LayoutItemDialog.vue?vue&type=template&id=16ef691f&scoped=true"
import script from "./LayoutItemDialog.vue?vue&type=script&lang=js"
export * from "./LayoutItemDialog.vue?vue&type=script&lang=js"
import style0 from "./LayoutItemDialog.vue?vue&type=style&index=0&id=16ef691f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef691f",
  null
  
)

export default component.exports